import React from 'react'
import Taxido from "../assets/illustrations/TaxiDo.png"

function CounterArea() {
  return (
    <div className="counter-area py-120">
        <div className="container">
            <div className="counter-wrapper mb-0">
                <div className="row">
                    <div className="col-lg-3 col-sm-6">
                        <div className="counter-box">
                            <div className="icon">
                                <img src={Taxido} alt="Taxi Service Icon" />
                            </div>
                            <div>
                                <span className="counter" data-count="+" data-to="500" data-speed="3000">500</span>
                                <h6 className="title">+ Rides Completed</h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <div className="counter-box">
                            <div className="icon">
                                <img src={Taxido} alt="Happy Clients Icon" />
                            </div>
                            <div>
                                <span className="counter" data-count="+" data-to="1200" data-speed="3000">1200</span>
                                <h6 className="title">+ Satisfied Customers</h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <div className="counter-box">
                            <div className="icon">
                                <img src={Taxido} alt="Handyman Icon" />
                            </div>
                            <div>
                                <span className="counter" data-count="+" data-to="350" data-speed="3000">350</span>
                                <h6 className="title">+ Skilled Professionals</h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <div className="counter-box">
                            <div className="icon">
                                <img src={Taxido} alt="Delivery Service Icon" />
                            </div>
                            <div>
                                <span className="counter" data-count="+" data-to="2000" data-speed="3000">2000</span>
                                <h6 className="title">+ Successful Deliveries</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default CounterArea